/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AgeListAgeResponse } from './AgeListAgeResponse';

export type AgeListAgeResponseApiRespoonse = {
    data?: AgeListAgeResponse;
    status?: AgeListAgeResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AgeListAgeResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

